import { EmailRecipient } from './email-recipient';

export class EmailInput {
  public userContactId?: number; // The contact ID of the connected user (the sender)
  public fromEmail?: string; // The required email of the sender
  public to?: EmailRecipient[]; // The emails of the recievers. At least, one email is required.
  public cc?: EmailRecipient[];
  public bcc?: EmailRecipient[];
  public subject?: string; // The required subject.
  public attachementIds?: [string]; // The iBox IDs of the mail files to be attached to email.
  public bodyHtml?: string;
  public jsonData: {
    fromEmail: string;
    to: EmailRecipient[];
    bcc: EmailRecipient[];
    cc: EmailRecipient[];
    subject: string;
    attachementIds: string[];
    bodyHtml?: string;
  };
  staticAttachments?: File[];
  constructor(data?: EmailInput) {
    Object.assign(this, data);
  }
}
